import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { setSearchFilters } from '../../../redux/actions';
import * as routes from '../../../constants/routes';
import { combineClassNames, findCategoryById, createFiltersUrl } from '../../../app/functions';
import filterIcon from '../../../assets/icons/filter-icon.svg';
import searchIcon from '../../../assets/icons/search-icon-white.svg';
import questionIcon from '../../../assets/icons/question-icon.svg';
import tipsIcon from '../../../assets/icons/tips-icon.svg';
import ButtonOutlined from '../../../components/common/buttons/button_outlined';
import SliderArrow from '../../../components/common/shared/slider_arrow';
import CategorySlider from '../../../components/common/sliders/category_slider';
import TagsSlider from '../../../components/common/sliders/tags_slider';
import './index.scss';

const SEARCH_REQUEST_DELAY = 1.5 * 1000;
const SEARCH_LENGTH_THRESHOLD = 2;

class Filters extends Component {
    constructor(props) {
        super(props);

        const { tagsDefaultVisibility, searchFilters } = this.props;

        this.state = {
            tagsVisible: tagsDefaultVisibility,
            searchQuery: searchFilters.textQuery.text,
            searchTimoutId: 0,
        };

        this.handleCategorySelect = this.handleCategorySelect.bind(this);
        this.handleCategoryRemove = this.handleCategoryRemove.bind(this);
        this.handleTagSelect = this.handleTagSelect.bind(this);
        this.handleTagRemove = this.handleTagRemove.bind(this);
        this.handleTagsButtonClick = this.handleTagsButtonClick.bind(this);
        this.handleTagsResetClick = this.handleTagsResetClick.bind(this);
        this.appendUrlParams = this.appendUrlParams.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleSearchQueryChange = this.handleSearchQueryChange.bind(this);
        this.getSearchPlaceholder = this.getSearchPlaceholder.bind(this);
        this.handleExpertButtonClick = this.handleExpertButtonClick.bind(this);
        this.handleMagazineButtonClick = this.handleMagazineButtonClick.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState) {
        const {
            availableCategories,
            availableTags,
            deviceState,
            searchFilters,
        } = this.props;

        return (
            availableCategories !== nextProps.availableCategories
            || availableTags !== nextProps.availableTags
            || deviceState !== nextProps.deviceState
            || searchFilters !== nextProps.searchFilters
            || this.state !== nextState
        );
    }

    handleCategorySelect(categoryId) {
        const { searchFilters } = this.props;

        const newFilters = {
            ...searchFilters,
            subCategory: {
                ...searchFilters.subCategory,
                id: categoryId,
            },
            benefitType: {
                ...searchFilters.benefitType,
                id: -1,
            },
        };

        this.appendUrlParams(newFilters);
        this.props.setSearchFilters(newFilters);
    }

    handleCategoryRemove() {
        this.handleCategorySelect(-1);
    }

    handleTagSelect(tagId) {
        const { searchFilters } = this.props;

        const newFilters = {
            ...searchFilters,
            benefitType: {
                ...searchFilters.benefitType,
                id: searchFilters.benefitType.id === -1 ? [tagId] : [...searchFilters.benefitType.id, tagId],
            },
        };

        this.appendUrlParams(newFilters);
        this.props.setSearchFilters(newFilters);
    }

    handleTagRemove(tagId) {
        const { searchFilters } = this.props;

        const newFilters = {
            ...searchFilters,
            benefitType: {
                ...searchFilters.benefitType,
                id: searchFilters.benefitType.id.filter(
                    (savedTagId) => savedTagId !== tagId
                ),
            },
        };

        if (newFilters.benefitType.id.length === 0) {
            newFilters.benefitType.id = -1;
        }

        this.appendUrlParams(newFilters);
        this.props.setSearchFilters(newFilters);
    }

    handleTagsButtonClick() {
        const newState = {
            ...this.state,
            tagsVisible: !this.state.tagsVisible,
        };

        this.setState(newState);
    }

    handleTagsResetClick() {
        const { searchFilters } = this.props;

        const newFilters = {
            ...searchFilters,
            benefitType: {
                ...searchFilters.benefitType,
                id: -1,
            },
        };

        this.appendUrlParams(newFilters);
        this.props.setSearchFilters(newFilters);
    }

    appendUrlParams(filters) {
        const { currentCategory } = this.props;

        const urlParams = {};

        for (const filterKey in filters) {
            if (filterKey === 'category') {
                continue;
            }

            if (filterKey === 'textQuery') {
                if (filters[filterKey].text) {
                    urlParams[filterKey] = filters[filterKey].text;
                }

                continue;
            }

            if (filters[filterKey].id !== -1) {
                urlParams[filterKey] = filters[filterKey].id;
            }
        }

        const stringUrlParams = createFiltersUrl(urlParams);

        const newUrl = `${routes.category}/${currentCategory.id}/${currentCategory.url_name}`
            + (stringUrlParams ? '?' + stringUrlParams : '');

        window.history.replaceState({}, null, newUrl);
    }

    handleFormSubmit(event) {
        const { searchFilters } = this.props;
        const { searchQuery, searchTimoutId } = this.state;

        event && event.preventDefault();
        searchTimoutId && clearTimeout(searchTimoutId);

        const newFilters = { ...searchFilters };

        // If the query is equal/longer than SEARCH_LENGTH_THRESHOLD, update the textQuery filter
        if (searchQuery.length >= SEARCH_LENGTH_THRESHOLD) {
            newFilters.textQuery.text = searchQuery;
        }

        // Otherwise, clear the textQuery filter
        else {
            newFilters.textQuery.text = '';
        }

        this.appendUrlParams(newFilters);
        this.props.setSearchFilters(newFilters);
    }

    handleSearchQueryChange(event) {
        const { searchTimoutId } = this.state;

        searchTimoutId && clearTimeout(searchTimoutId);

        this.setState({
            ...this.state,
            searchQuery: event.target.value,
            searchTimoutId: setTimeout(
                this.handleFormSubmit, SEARCH_REQUEST_DELAY
            ),
        });
    }

    getSearchPlaceholder() {
        const { currentCategory, translations, searchFilters } = this.props;

        // If there's a selected sub-category, show a placeholder for that one
        if (searchFilters.subCategory.id !== -1) {
            const selectedSubCategory = findCategoryById(currentCategory.subCategories, searchFilters.subCategory.id);

            if (selectedSubCategory) {
                return translations['category_search_placeholder'] + selectedSubCategory.name;
            }
        }

        // Otherwise, show a placeholder for the category page itself
        return translations['category_search_placeholder'] + currentCategory.name;
    }

    handleExpertButtonClick() {
        const { currentCategory, history } = this.props;

        if (currentCategory.relatedExpert !== '0') {
            history.push(`${routes.experts}?id=${currentCategory.relatedExpert}`);
        } else {
            history.push(routes.experts);
        }
    }

    handleMagazineButtonClick() {
        const { currentCategory, history } = this.props;

        if (currentCategory.relatedMagazine) {
            history.push(`${routes.magazine}/${currentCategory.relatedMagazine}`);
        } else {
            history.push(routes.magazine);
        }
    }

    render() {
        const {
            currentCategory,
            availableCategories,
            availableTags,
            translations,
            deviceState,
            searchFilters,
        } = this.props;
        const { searchQuery, tagsVisible } = this.state;

        const isMobileOrTablet = (deviceState === 'mobile' || deviceState === 'tablet');

        const selectedCategory = searchFilters.subCategory.id;
        const selectedTags = Array.isArray(searchFilters.benefitType.id) ? searchFilters.benefitType.id : [];

        const hasSelectedTags = (searchFilters.benefitType.id !== -1);

        const searchPlaceholder = this.getSearchPlaceholder();

        const TagsToggleButton = (
            <ButtonOutlined
                type="button"
                className="filters-tags-button"
                onClick={this.handleTagsButtonClick}
            >
                <img
                    src={filterIcon}
                    alt="Filter Icon"
                    className="filters-tags-button-icon"
                />

                {translations['category_tags_button']}
            </ButtonOutlined>
        );

        const TagsCloseButton = (
            <button
                type="button"
                className="filters-link-button"
                onClick={this.handleTagsButtonClick}
            >
                {translations['category_close_button']}
            </button>
        );

        const TagsResetButton = (
            <button
                type="button"
                className="filters-link-button"
                onClick={this.handleTagsResetClick}
            >
                {translations['category_reset_button']}
            </button>
        );

        const ExpertButton = (
            <button
                type="button"
                className="category-expert-button"
                onClick={this.handleExpertButtonClick}
            >
                <img
                    src={questionIcon}
                    alt="Question Icon"
                    className="category-expert-button-icon"
                />

                {translations['category_expert_button']}
            </button>
        );

        const MagazineButton = (
            <button
                type="button"
                className="category-magazine-button"
                onClick={this.handleMagazineButtonClick}
            >
                <img
                    src={tipsIcon}
                    alt="Tips Icon"
                    className="category-magazine-button-icon"
                />

                {translations['category_magazine_button'] + (
                    currentCategory.relatedMagazine ? ` ${currentCategory.relatedMagazine}` : ''
                )}
            </button>
        );

        const TagsRow = (
            <div
                className={combineClassNames(
                    'filters-tags-row',
                    this.state.tagsVisible && 'filters-tags-row_visible',
                )}
            >
                <div className="filters-tags">
                    <TagsSlider
                        selectedTags={selectedTags}
                        availableTags={availableTags}
                        onTagSelect={this.handleTagSelect}
                        onTagRemove={this.handleTagRemove}
                        customSliderSettings={{
                            mobile: {
                                slidesToShow: 2,
                                slidesToScroll: 2,
                            },
                            tablet: {
                                slidesToShow: 3,
                                slidesToScroll: 3,
                            },
                            desktop: {
                                slidesToShow: 3,
                                slidesToScroll: 3,
                            },
                            desktopLarge: {
                                slidesToShow: 4,
                                slidesToScroll: 4,
                            },
                        }}
                    />
                </div>

                {!isMobileOrTablet && (
                    <div className="filters-actions-line">
                        {TagsCloseButton}

                        {hasSelectedTags && TagsResetButton}
                    </div>
                )}
            </div>
        );

        return (
            <section className="category-filters-container">
                <div className="filters-upper-row">
                    {availableCategories.length > 1 && (
                        <div className="filters-categories">
                            <CategorySlider
                                selectedCategory={selectedCategory}
                                availableCategories={availableCategories}
                                onCategorySelect={this.handleCategorySelect}
                                onCategoryRemove={this.handleCategoryRemove}
                                customSliderSettings={{
                                    shared: {
                                        nextArrow: isMobileOrTablet
                                            ? (<SliderArrow />)
                                            : (<SliderArrow variant="circular" />),
                                        prevArrow: isMobileOrTablet
                                            ? (<SliderArrow />)
                                            : (<SliderArrow variant="circular" />),
                                    },
                                    mobile: {
                                        slidesToShow: 4,
                                        slidesToScroll: 4,
                                    },
                                    tablet: {
                                        slidesToShow: 5,
                                        slidesToScroll: 5,
                                    },
                                    desktop: {
                                        slidesToShow: 6,
                                        slidesToScroll: 6,
                                    },
                                    desktopLarge: {
                                        slidesToShow: 7,
                                        slidesToScroll: 7,
                                    },
                                }}
                            />
                        </div>
                    )}

                    {isMobileOrTablet && (
                        <div
                            className={combineClassNames(
                                'filters-tags-button-container',
                                isMobileOrTablet && availableCategories.length <= 1 && 'compact',
                            )}
                        >
                            <div>
                                {tagsVisible && TagsCloseButton}
                            </div>

                            {TagsToggleButton}

                            <div>
                                {hasSelectedTags && TagsResetButton}
                            </div>
                        </div>
                    )}
                </div>

                {isMobileOrTablet && TagsRow}

                <div
                    className={combineClassNames(
                        'filters-lower-row',
                        !isMobileOrTablet && availableCategories.length <= 1 && 'compact',
                    )}
                >
                    <form className="search-form" onSubmit={this.handleFormSubmit}>
                        <input
                            type="text"
                            className="search-input"
                            placeholder={searchPlaceholder}
                            value={searchQuery}
                            onChange={this.handleSearchQueryChange}
                        />

                        <button
                            type="submit"
                            className="search-button"
                        >
                            <img
                                src={searchIcon}
                                alt="Search Icon"
                                className="search-button-icon"
                            />
                        </button>
                    </form>

                    {!isMobileOrTablet && TagsToggleButton}

                    <div className="category-actions">
                        {ExpertButton}

                        <div className="actions-divider" />

                        {MagazineButton}
                    </div>
                </div>

                {!isMobileOrTablet && TagsRow}
            </section>
        );
    }
}

const mapStateToProps = (store) => {
    return {
        translations: store.config.Translations,
        deviceState: store.state.deviceState,
        searchFilters: store.state.benefitSearchFilters,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setSearchFilters: (payload) => dispatch(setSearchFilters(payload)),
    };
};

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(Filters)
);
